import React from 'react';
import PropTypes from 'prop-types';

/**
 * MarkdownCell — one cell of a rendered markdown table. Renders a <th> or <td> (per `tag`) with
 * the caller-supplied className and already-rendered inline content as children. Shared by the
 * header and body cells so both go through the same component; markup stays byte-identical.
 */
export default function MarkdownCell({ tag, className, children }) {
  const Tag = tag;
  return <Tag className={className}>{children}</Tag>;
}
MarkdownCell.propTypes = {
  tag: PropTypes.oneOf(['th', 'td']).isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.node,
};
MarkdownCell.defaultProps = { children: null };
